import React, { act, useEffect, useState } from 'react';
import { ArrowLeft, Edit2, Trash2 } from 'lucide-react';
import AssetImagesSection from './Assetimagessection';
import AssetDocumentsSection from './Assetdocumentssection';
import '../styles/assetDetailPage.css';
import { useNavigate } from 'react-router-dom';
import Apis from '../services/apis';
import { useSearchParams } from "react-router-dom";

const AssetDetailPage = () => {
  const navigate = useNavigate();
  const apis = new Apis();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [load,setLoad]=useState(true);
  const [asset,setasset]=useState({});
  const [category,setcategory]=useState({});
  const [images,setImages] = useState([])
  const [documents,setDocuments] = useState([])
  const[primary,setprimary]=useState(null);
  const [res,setRes] = useState({});

  useEffect(() => {
    getHolding()
  }, []);
    
  const getHolding = () => {
    apis.getHoldingById(id)
    .then((response) => {
        let data = response.data
        setasset(data.asset);
        setcategory(data.asset.category);
        setImages(data.images || [])
        setDocuments(data.documents || [])

        let item = data.images.find(img => img.isPrimary);
        console.log("Primary Image:", item);
        setprimary(item ? item.imageUrl : null);
        setRes(data);
        setLoad(false)
    })
    .catch((error) => {
        if (error.response && error.response.status === 404) {
            setLoad(false)
            alert("Error occurred while fetching categories "+ error.response.data.message);
        } else {
            // Handle other errors
            console.error("Error:", error);
            alert("Error occurred while fetching asset data");
        }
    });
  }
    
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = [
    { id: 'overview', label: 'Overview' },
    { id: 'images', label: 'Images' },
    { id: 'documents', label: 'Documents' }
  ];
  if (load) {
    return (
      <div style={{
        height: '80vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div
          style={{
            width: '80px',
            height: '80px',
            border: '10px solid rgba(255,255,255,0.2)',
            borderTop: '10px solid #F4A31E',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}
        />
      </div>
    );
  }
  else { 
    return (
      <div className="detail-page">
        {/* Header */}
        <div className="detail-header">
          <div className="detail-header-content" style={{marginTop:10}}>
            <div className="detail-header-left" style={{}}>
              <button onClick={()=>{navigate(-1)}} className="back-button">
                <ArrowLeft size={24} />
              </button>
              <div className="detail-title-section">
                <h1 className="detail-title">{asset.name}</h1>
                <p className="detail-subtitle">{asset.subtitle}</p>
              </div>
            </div>
            <div className="detail-header-actions">
              {/* <button onClick={() => {}} className="action-button action-button-edit">
                <Edit2 size={18} />
                <span className="action-button-text">Edit</span>
              </button>
              <button onClick={() => {}} className="action-button action-button-delete">
                <Trash2 size={18} />
                <span className="action-button-text">Delete</span>
              </button> */}
            </div>
          </div>

          {/* Tabs */}
          <div className="detail-tabs-container">
            <div className="detail-tabs" style={{marginLeft:20}}>
              {tabs.map(tab => (
                <button
                  key={tab.id}
                  style={{marginRight:20}}
                  onClick={() => {
                    if(tab.id == "overview")
                    {
                      setActiveTab(tab.id)
                      setLoad(true)
                      getHolding()
                    }
                    else{
                      setActiveTab(tab.id)
                    }
                  }
                  }
                  className={`tab-button ${activeTab === tab.id ? 'tab-button-active' : ''}`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="detail-content">
          {activeTab === 'overview' && (
            <div className="overview-container">
              <div className="detail-card">
                <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'space-between'}}>
                  <h3 className="card-title" style={{marginBottom:'10px'}}>Asset Details</h3>
                  {category && (
                  <div 
                    // style={{backgroundColor:"#fff"}}
                  >
                    <div
                      className="category-badge"
                      style={{
                        // backgroundColor: `${category.color}`,
                        // color: category.color,
                        // borderColor: `${category.color}`

                        backgroundColor: `${category.color}22`,
                        color: category.color,
                        borderColor: `${category.color}`
                      }}
                    >
                      {/* {category.icon && (
                        <img src={category.icon} alt="" className="category-icon" style={{filter: 'brightness(0) invert(1)'}}/>
                      )} */}
                      <span style={{}}>{category.label}</span>
                    </div>
                  </div>
                  )}
                </div>
                <hr></hr>
                {/* <div style={{display:'flex',flexDirection:'row'}}>
                  {primary && (
                  <div className="asset-main-image">
                    <img src={primary} alt={asset.name} className="main-image" />
                  </div>
                  )}
                  <div className="details-grid" style={{marginTop:'30px'}}>
                    {asset?.metadata &&
                    Object.entries(asset.metadata).map(([key, value], index) => (
                      <div className="detail-item" key={index}>
                        <p className="detail-label">
                          {key.replace(/_/g, ' ').toUpperCase()}
                        </p>
                        <p className="detail-value">
                          {String(value)}
                        </p>
                      </div>
                    ))}
                  </div>
                </div> */}

                <div
                  style={{
                    display: 'flex',
                    gap: '32px',
                    alignItems: 'flex-start',
                    width: '100%',
                    flexWrap: 'wrap',
                    marginTop: '40px'
                  }}
                >
                  {/* Left – Primary Image */}
                  {primary && (
                    <div
                      className="asset-main-image"
                      style={{
                        flex: '0 0 320px',
                      }}
                    >
                      <img
                        src={primary}
                        alt={asset.name}
                        className="main-image"
                        style={{
                          width: '100%',
                          height: '300px',
                          borderRadius: '12px',
                          objectFit: 'contain'
                        }}
                      />
                    </div>
                  )}

                  {/* Right – Metadata */}
                  <div
                    className="details-grid"
                    style={{
                      flex: '1',
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fit, minmax(min(180px, 100%), 320px))',
                      gap: '20px',
                     
                    }}
                  >

                        <div
                          className="detail-item"
                          style={{
                            background: '#111',
                            border: '1px solid #1f1f1f',
                            borderRadius: '10px',
                            padding: '14px'
                          }}
                        >
                          <p
                            className="detail-label"
                            style={{
                              fontSize: '11px',
                              color: '#888',
                              marginBottom: '6px',
                              letterSpacing: '0.5px'
                            }}
                          >
                            ACQUISITION PRICE
                          </p>
                          <p
                            className="detail-value"
                            style={{
                              fontSize: '14px',
                              fontWeight: '500',
                              color: '#fff',
                              wordBreak: 'break-word'
                            }}
                          >
                            {res.acquiredPrice? String(res.acquiredPrice): 'N/A'}
                          </p>
                        </div>



                        <div
                          className="detail-item"
                          style={{
                            background: '#111',
                            border: '1px solid #1f1f1f',
                            borderRadius: '10px',
                            padding: '14px'
                          }}
                        >
                          <p
                            className="detail-label"
                            style={{
                              fontSize: '11px',
                              color: '#888',
                              marginBottom: '6px',
                              letterSpacing: '0.5px'
                            }}
                          >
                            ACQUISITION DATE
                          </p>
                          <p
                            className="detail-value"
                            style={{
                              fontSize: '14px',
                              fontWeight: '500',
                              color: '#fff',
                              wordBreak: 'break-word'
                            }}
                          >
                            {res.acquiredDate? String(res.acquiredDate).split("T")[0]: 'N/A'}
                          </p>
                        </div>



                    {asset?.metadata &&
                      Object.entries(asset.metadata).map(([key, value]) => (
                        <div
                          className="detail-item"
                          key={key}
                          style={{
                            background: '#111',
                            border: '1px solid #1f1f1f',
                            borderRadius: '10px',
                            padding: '14px'
                          }}
                        >
                          <p
                            className="detail-label"
                            style={{
                              fontSize: '11px',
                              color: '#888',
                              marginBottom: '6px',
                              letterSpacing: '0.5px'
                            }}
                          >
                            {key.replace(/_/g, ' ').toUpperCase()}
                          </p>
                          <p
                            className="detail-value"
                            style={{
                              fontSize: '14px',
                              fontWeight: '500',
                              color: '#fff',
                              wordBreak: 'break-word'
                            }}
                          >
                            {value? String(value): 'N/A'}
                          </p>
                        </div>
                      ))}
                  </div>
                </div>



              </div>

              {/* <div className="detail-card">
             
              {primary && (
                <div className="asset-main-image">
                  <img src={primary} alt={asset.name} className="main-image" />
                </div>
              )}              
              </div> */}
            </div>
          )}

          {activeTab === 'images' && (
            <AssetImagesSection assetId={id} docimages={images || []} id = {id}/>
          )}

          {activeTab === 'documents' && (
            <AssetDocumentsSection assetId={id} docs={documents || []}/>
          )}
        </div>
      </div>
    );
  }
};

export default AssetDetailPage;